/* eslint-disable */
export default {
  confirmation: 'Confirmation',
  confirmMergeToConference: 'Ajouter à la téléconférence?',
  mergeToConference: 'Fusionner',
  conferenceCall: 'Téléconférence',
} as const;

// @key: @#@"confirmation"@#@ @source: @#@"Confirmation"@#@
// @key: @#@"confirmMergeToConference"@#@ @source: @#@"Add to conference call?"@#@
// @key: @#@"mergeToConference"@#@ @source: @#@"Merge"@#@
// @key: @#@"conferenceCall"@#@ @source: @#@"Conference Call"@#@
